module.exports = __webpack_public_path__ + "static/012.thumb-c34c9b76208c6a3daea27e0d117915c6.jpg";